'use strict';
import * as $j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dBank$002dAccount$002dNumber$0024 from "./app.data.-Payment-Details$package$-Bank-Account-Number$.js";
import * as $j_app$002elocalization$002e$002dApp$002dLocale$0024 from "./app.localization.-App-Locale$.js";
import * as $j_app$002elocalization$002epackage$0024 from "./app.localization.package$.js";
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_PaymentDetails$package$BankAccountNumberForm$() {
  this.aEe = null;
  this.aEr = null;
  this.aEj = null;
  this.aEk = false;
  this.aEp = null;
  this.aEq = false;
  this.aEf = null;
  this.aEg = false;
  this.aEn = null;
  this.aEo = false;
  this.aEl = null;
  this.aEm = false;
  this.aEh = null;
  this.aEi = false;
  $n_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ = this;
  this.aEe = $j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dBank$002dAccount$002dNumber$0024.$m_Lapp_data_PaymentDetails$package$BankAccountNumber$();
  this.aEr = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_prelude_neotype\uff3fchimney$package$().eU($j_app$002edata$002e$002dPayment$002dDetails$0024package$0024$002dBank$002dAccount$002dNumber$0024.$m_Lapp_data_PaymentDetails$package$BankAccountNumber$());
}
export { $c_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ as $c_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ };
$p = $c_Lapp_data_PaymentDetails$package$BankAccountNumberForm$.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$p.constructor = $c_Lapp_data_PaymentDetails$package$BankAccountNumberForm$;
/** @constructor */
function $h_Lapp_data_PaymentDetails$package$BankAccountNumberForm$() {
}
export { $h_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ as $h_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ };
$h_Lapp_data_PaymentDetails$package$BankAccountNumberForm$.prototype = $p;
$p.eR = (function() {
  return this.aEe;
});
$p.eO = (function() {
  return this.aEr;
});
$p.b9 = (function() {
  if ((!this.aEk)) {
    this.aEj = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$1(this);
    this.aEk = true;
  }
  return this.aEj;
});
$p.b3 = (function() {
  if ((!this.aEq)) {
    this.aEp = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$5(this);
    this.aEq = true;
  }
  return this.aEp;
});
$p.aG = (function() {
  if ((!this.aEg)) {
    this.aEf = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UnvalidatedNewtypeOf$$anon$6(this);
    this.aEg = true;
  }
  return this.aEf;
});
$p.az = (function() {
  if ((!this.aEo)) {
    this.aEn = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_UnvalidatedNewtypeOf__partialTransformer__Lio_scalaland_chimney_PartialTransformer(this);
    this.aEo = true;
  }
  return this.aEn;
});
$p.aY = (function() {
  if ((!this.aEm)) {
    this.aEl = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_utils_Validatable$().eS(this.az());
    this.aEm = true;
  }
  return this.aEl;
});
$p.brT = (function() {
  if ((!this.aEi)) {
    this.aEh = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_localization_LocalizationSupport$$anon$5(new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_sjsr_AnonFunction1(((x$1) => {
      var x = $j_app$002elocalization$002e$002dApp$002dLocale$0024.$s_Lapp_localization_AppLocale$__En__Lapp_localization_AppLocale();
      if (((x === null) ? (x$1 === null) : (x === x$1))) {
        return "Bank Account Number";
      }
      throw new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$c_s_MatchError(x$1);
    })), $j_app$002elocalization$002epackage$0024.$m_Lapp_localization_package$().cN());
    this.aEi = true;
  }
  return this.aEh;
});
var $d_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_PaymentDetails$package$BankAccountNumberForm$, "app.data.PaymentDetails$package$BankAccountNumberForm$", ({
  ED: 1,
  N: 1
}));
export { $d_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ as $d_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ };
var $n_Lapp_data_PaymentDetails$package$BankAccountNumberForm$;
function $m_Lapp_data_PaymentDetails$package$BankAccountNumberForm$() {
  if ((!$n_Lapp_data_PaymentDetails$package$BankAccountNumberForm$)) {
    $n_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ = new $c_Lapp_data_PaymentDetails$package$BankAccountNumberForm$();
  }
  return $n_Lapp_data_PaymentDetails$package$BankAccountNumberForm$;
}
export { $m_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ as $m_Lapp_data_PaymentDetails$package$BankAccountNumberForm$ };
//# sourceMappingURL=app.data.-Payment-Details$package$-Bank-Account-Number-Form$.js.map
